module.exports = __webpack_public_path__ + "stu-res/img/j-01@3x.940bf570.png";